<template>
  <div>
  <a v-if="item.style==='link'" :style="[
    {fontSize: item.size, fontWeight: item.weight},
    item.color?{backgroundColor: item.color}:{},
    item.height?{
      height: item.height === 'sm' ? '40px' : '52px'
    }:{}
  ]">{{item.action.label}}</a>
  <button v-else :class="item.style" :style="[
    {fontSize: item.size, fontWeight: item.weight},
    item.color?{color: item.color}:{}
  ]">{{item.action.label}}</button>

</div>
</template>

<script>
export default {
  props: ['item']

}
</script>

<style lang="scss" scoped>
a {
  color: #42659a;
}
button, a {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
button.secondary {
  background-color: #dcdfe5;
  color: #111111;
}
button.primary {
  background-color: #17c950;
  color: #ffffff;
}

</style>
